import { Avatar, Box, HStack, Text, VStack, theme } from '@squire/ui';

import { styles } from './styles';
import type { ShopDetailsProps } from './types';

const ShopDetails = ({ shop, withImageFallback = false }: ShopDetailsProps) => {
  if (!shop) return null;

  const shopImage = withImageFallback
    ? shop.photos?.[0]?.thumbnail ||
      shop.photos?.[0]?.url ||
      shop.logo?.thumbnail ||
      shop.logo?.url
    : shop.photos?.[0]?.thumbnail ||
      shop.photos?.[0]?.url ||
      shop.staticMap?.url;

  const fullAddress = shop.address
    ? `${shop.address.street}, ${shop.address.city}, ${shop.address.state} ${shop.address.zip}`
    : '';

  return (
    <HStack space={theme.spacing[6]}>
      {(shopImage || withImageFallback) && (
        <Box
          style={styles.shopImageContainer}
          {...(withImageFallback && {
            accessibilityElementsHidden: true,
            importantForAccessibility: 'no-hide-descendants' as const,
          })}
        >
          <Avatar
            shape="square"
            uri={shopImage || undefined}
            style={styles.shopImage}
            fallbackText={
              withImageFallback
                ? shop.name?.charAt(0)?.toUpperCase()
                : shop.name
            }
          />
        </Box>
      )}

      <VStack style={styles.shopInfoContainer}>
        <Text variant="lStrong" color="textPrimary">
          {shop.name}
        </Text>
        {fullAddress && (
          <Text
            variant="m"
            color="textSecondary"
            numberOfLines={2}
            ellipsizeMode="tail"
            style={styles.address}
          >
            {fullAddress}
          </Text>
        )}
      </VStack>
    </HStack>
  );
};

ShopDetails.displayName = 'ShopDetails';
export { ShopDetails };
